export default __webpack_public_path__ + "static/media/popup-addons-item-icn3.40a3f0d4.jpg";